
import t2m_colorlist from "./json/colormaps/t2m.json";
import td2m_colorlist from "./json/colormaps/td2m.json";
import spd500mb_colorlist from "./json/colormaps/spd500mb.json";
import spd850mb_colorlist from "./json/colormaps/spd850mb.json";
import cape_colorlist from "./json/colormaps/cape.json";

class Colormap {
    constructor(colormap) {
        this.colormap = colormap
        this.length = colormap['colors'].length;
    }

    getMap() {
        return this.colormap['colors'];
    }

    getColorbarInfo() {
        return this.colormap['colorbar'];
    }

    getLevels() {
        return this.getMap().map(s => s['level']);
    }

    getColors() {
        return this.getMap().map(s => s['color']);
    }

    getOpacities() {
        return this.getMap().map(s => s['opacity']);
    }
}

const t2m_colormap = new Colormap(t2m_colorlist)
const td2m_colormap = new Colormap(td2m_colorlist)
const spd500mb_colormap = new Colormap(spd500mb_colorlist)
const spd850mb_colormap = new Colormap(spd850mb_colorlist)
const cape_colormap = new Colormap(cape_colorlist)

export {t2m_colormap, td2m_colormap, spd500mb_colormap, spd850mb_colormap, cape_colormap};